import * as React from "react";
import * as DetailTopBar from "./DetailTopBar";
import { withRouter } from "react-router";
class MerchantDetailTopBar extends React.Component<any, any> {
  render() {
    return (
      <DetailTopBar.Bar>
        <DetailTopBar.Item
          text="SnapCode"
          link={`/snapscan/ops/merchants/${this.props.match.params.id}/snapcode`}
        />
        <DetailTopBar.Item
          text="Payments"
          link={`/snapscan/ops/merchants/${this.props.match.params.id}/payments`}
        />
        <DetailTopBar.Item
          text="Rates"
          link={`/snapscan/ops/merchants/${this.props.match.params.id}/rates`}
        />
        <DetailTopBar.Item
          text="Cashback Strategy"
          link={`/snapscan/ops/merchants/${this.props.match.params.id}/cashback`}
        />
        <DetailTopBar.Item
          text="Tags"
          link={`/snapscan/ops/merchants/${this.props.match.params.id}/tags`}
        />
      </DetailTopBar.Bar>
    );
  }
}

const MerchantDetailTopBarWithRouter = withRouter(MerchantDetailTopBar);
export default MerchantDetailTopBarWithRouter;
